import { ACCESS_TOKEN_KEY } from "./constant";
import Cookies from "js-cookie";
// import { getNotifyNum } from "./UserService";

// Get and store access_token in local storage
export function getAccessToken() {
  const cookieToken = Cookies.get(ACCESS_TOKEN_KEY);
  if (cookieToken) {
    return Cookies.get(ACCESS_TOKEN_KEY);
  }
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    return token;
  } else {
    logout();
    // window.location.href = "/";
    return false;
  }
}

export function setAccessToken(accessToken, isRememberMe) {
  if (isRememberMe) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  } else {
    Cookies.set(ACCESS_TOKEN_KEY, accessToken);
  }
}

export function isLoggedIn() {
  const accessToken = getAccessToken();
  return !!accessToken;
}

export function getLoggedInUser() {

  let loggedUser = undefined;
  const user = localStorage.getItem("user");

  if (user && user !== undefined) {
    try {
      loggedUser = JSON.parse(user);
      // getNotifyNum(loggedUser._id);
    } catch (err) {
      console.log("error catch", err)
    }

  }
  return loggedUser;
}
export function getSelectedSubUser() {
  var selectedUser = localStorage.getItem("Dashboard_User_Selected");
  return JSON.parse(selectedUser);
}

export function logout() {
  Cookies.remove(ACCESS_TOKEN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem("lastUpdateSyptoms");
  localStorage.removeItem("user");
  // localStorage.clear();
  const keyToKeep = 'i18nextLng';

  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key !== keyToKeep) {
      localStorage.removeItem(key);
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js